<div class="login">
    <form class="login-modal" [formGroup]="form" #localForm="ngForm" (ngSubmit)="submitForm(form.valid)">
        <h1>Login</h1>
        <div class="input-column">
            <label for="user">User</label>
            <input type="text" formControlName="user">
            <small *ngIf="localForm.submitted && form.get('user')?.invalid" class="invalid">*User is invalid</small>
        </div>
        <div class="input-column">
            <label for="password">Password</label>
            <input formControlName="password" type="password">
            <small *ngIf="localForm.submitted && form.get('password')?.invalid" class="invalid" class="invalid">*Password is invalid</small>
        </div>
        <button type="submit">Submit</button>
    </form>
</div>